var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[(_vm.loginUserInfo.auth_req_estimate)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'estimate' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'RequestEstimate',
          'loadHTML_forRequestEstimate',
          {},
          '',
          '/request/estimate.html'
        )}}},[_vm._v("見積依頼")])]):_vm._e(),(_vm.loginUserInfo.auth_req_sample)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'sample' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'RequestSample',
          'loadHTML_forRequestSample',
          {},
          '',
          '/request/sample.html'
        )}}},[_vm._v("サンプル依頼")])]):_vm._e(),(_vm.loginUserInfo.auth_req_catalogue)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'catalog' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'RequestCatalog',
          'loadHTML_forRequestCatalog',
          {},
          '',
          '/request/catalogue.html'
        )}}},[_vm._v("カタログ")])]):_vm._e(),(_vm.loginUserInfo.auth_req_envdocument)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'environment' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'RequestEnvironment',
          'loadHTML_forRequestEnvironment',
          {},
          '',
          '/request/environment.html'
        )}}},[_vm._v("環境書類")])]):_vm._e(),(_vm.hasRequestState)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'request_status' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.linkToRequestState($event)}}},[_vm._v("依頼状況")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }